import { queryOptions, type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { ItemTypeFieldsApi } from '@/common/api/itemTypeFields';
import type { CustomField } from '@/common/api/types/customField';
import { commonQueryKeys } from '@/common/queryKeys/common';

export const itemTypeFieldsQueryOptions = (
  itemTypeId: number,
  { includeArchived = false }: { includeArchived?: boolean } = {},
) => {
  return queryOptions<CustomField[]>({
    queryKey: [...commonQueryKeys.itemTypes.fields(itemTypeId), { includeArchived }],
    queryFn: () => ItemTypeFieldsApi.getFieldsForItemType(itemTypeId, { includeArchived }),
    enabled: !!itemTypeId,
  });
};

export const useItemTypeFieldsQuery = (
  itemTypeId: number,
  {
    includeArchived = false,
    ...options
  }: { includeArchived?: boolean } & Partial<UseQueryOptions<CustomField[]>> = {},
) => {
  return useQuery({
    ...itemTypeFieldsQueryOptions(itemTypeId, { includeArchived }),
    ...options,
  });
};
